function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.5718 37.7114V42.0245C69.5718 44.2709 67.7747 46.068 65.5283 46.068H6.0433C3.79689 46.068 1.99976 44.2709 1.99976 42.0245V6.08187C1.99976 3.83546 3.79689 2.03833 6.0433 2.03833H65.5283C67.7747 2.03833 69.5718 3.83546 69.5718 6.08187V30.2533",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.39111 8.50781H32.1915",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.3801 8.50781H64.1805",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.39111 13.3604H32.1915",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.3801 13.3604H64.1805",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.39111 18.1226H32.1915",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.3801 18.1226H64.1805",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.45801 46.158V51.1001",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.2869 46.158V51.1001",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54.3862 46.158V51.1001",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.2153 46.158V51.1001",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.8349 39.3287C26.8901 39.3287 29.406 36.8127 29.406 33.7576C29.406 30.7025 26.8901 28.1865 23.8349 28.1865H17.0957V39.3287H23.8349Z",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.0957 36.3633H10.5361",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.0959 31.2419H10.5364",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.3159 33.8477H73.1659C75.4123 33.8477 77.2993 35.7346 77.2993 37.9811C77.2993 40.2275 75.4123 42.1145 73.1659 42.1145",
  stroke: "#1E1E1E",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var SvgHeating = function SvgHeating(props) {
  return React.createElement("svg", _extends({
    width: 79,
    height: 52,
    viewBox: "0 0 79 52",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

export default __webpack_public_path__ + "static/media/heating.6372a709.svg";
export { SvgHeating as ReactComponent };